import { ArrowUpRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useLocale } from "@/i18n/context";
import { localizedPath } from "@/i18n/routes";
import { getGuideByPath, hubListing, GUIDE_UI } from "@/content/guides/registry";

const GuideHub = () => {
  const { pathname } = useLocation();
  const { locale } = useLocale();
  const entry = getGuideByPath(pathname);
  const ui = GUIDE_UI[locale as "sl" | "en"] ?? GUIDE_UI.sl;
  const homePath = localizedPath("home", locale);
  const guides = hubListing(locale);

  const hub = entry?.content as
    | { h1: string; intro: string; eyebrow: string }
    | undefined;

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-16 bg-background">
        <div className="container mx-auto px-5 py-14 sm:px-8 sm:py-20 max-w-6xl">
          <nav
            aria-label="Breadcrumb"
            className="mb-6 flex flex-wrap items-center gap-2 text-sm text-muted-foreground"
          >
            <Link to={homePath} className="hover:text-primary">
              {ui.home}
            </Link>
            <span aria-hidden>/</span>
            <span className="text-foreground">{ui.hubBreadcrumb}</span>
          </nav>

          <p className="section-eyebrow mb-3">{hub?.eyebrow ?? ui.hubBreadcrumb}</p>
          <h1 className="section-title text-left mb-4">{hub?.h1}</h1>
          <p className="mb-10 max-w-2xl text-lg leading-relaxed text-muted-foreground">
            {hub?.intro}
          </p>

          <ul className="grid gap-x-12 gap-y-3 sm:grid-cols-2">
            {guides.map((guide, index) => (
              <li key={guide.path}>
                <Link
                  to={guide.path}
                  className="guide-index-card group flex h-full flex-col border-t border-border py-7 transition-colors hover:border-primary/50"
                >
                  <span className="mb-5 flex items-center justify-between text-xs text-muted-foreground"><span>{String(index + 1).padStart(2,"0")}</span><ArrowUpRight className="h-5 w-5 text-primary transition-transform group-hover:translate-x-0.5" /></span>
                  <span className="text-lg font-semibold text-foreground">
                    {guide.title}
                  </span>
                  <span className="mt-2 text-sm leading-relaxed text-muted-foreground">
                    {guide.description}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GuideHub;
